export const getLoggedInUserId=()=>{
const userId=localStorage.getItem("loggedEmployee")
return userId;
}

